// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__bLKNH","signatureButtonsRight":"ModalSign_signatureButtonsRight__1JEVp"};